"use client"
import { getCookie } from "cookies-next"
import { NavigationGuardProvider } from "next-navigation-guard"
import posthog from "posthog-js"
import { PostHogProvider as PostHog } from "posthog-js/react"
import { Suspense, useEffect } from "react"
import { env } from "@/env/client"
import PostHogPageView from "./page-view"

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (!env.NEXT_PUBLIC_PRODUCTION_MODE) return

    const getBootstrapData = () => {
      try {
        const flags = getCookie("bootstrapData") as string
        if (!flags) return {}
        return JSON.parse(flags)
      } catch (_) {
        return {}
      }
    }

    posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: `${env.NEXT_PUBLIC_BASE_URL}/ingest`,
      ui_host: env.NEXT_PUBLIC_POSTHOG_HOST,
      capture_pageview: false, // Disable automatic pageview capture, as we capture manually
      capture_pageleave: false, // Disable automatic pageleave capture, as we capture manually
      bootstrap: getBootstrapData(),
    })
  }, [])

  if (!env.NEXT_PUBLIC_PRODUCTION_MODE) return children

  return (
    <NavigationGuardProvider>
      <PostHog client={posthog}>
        <Suspense children={<PostHogPageView />} />
        {children}
      </PostHog>
    </NavigationGuardProvider>
  )
}
